import {Body, Desc, Images, Logo, Next, PageIcon, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";
import {useNavigate, useParams} from "react-router-dom";
import {ContainerImage} from "../../components/Container";
import React, {useCallback} from "react";

export default function Success(props: any) {
    const {
        groupSlug,
        shareUrlKey,
    } = useParams();
    const navigate = useNavigate();
    const {T} = useApp();
    const {themeColors, clientCode} = useApp();

    const onNext = useCallback(() => {
        localStorage.clear();
        // Navigate to home page
        navigate(`/${groupSlug}/${shareUrlKey}`, {replace: true});
    }, [navigate, clientCode, groupSlug, shareUrlKey]);

    return (
        <ContainerImage style={{minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Logo style={{
                height: (!themeColors?.main ? "auto" : 0),
                opacity: (!themeColors?.main ? 1 : 0)
            }}>
                <LogoIcon style={{height: 81, marginTop: 30, width: 'auto'}}/>
            </Logo>
            <Body>
                <Images>
                    <PageIcon mainColor={themeColors?.main}/>
                </Images>
                <Title>
                    <h3>{T("We've got your booking!")}</h3>
                    <p>{T('A confirmation email will be sent to you shortly.')}<br/>{T('Thank you and have a nice day!')}
                    </p>
                </Title>
                <Desc></Desc>

                <Next onClick={onNext}>{T("Done")}</Next>
            </Body>
        </ContainerImage>
    );
}
